'use client';

import { useState, useEffect } from 'react';
import useUserImpersonation from 'src/hooks/users/useUserImpersonation';
import { useAuth } from 'src/context/auth';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faUserNinja, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useCountdown } from 'src/utils/hooks/useCountdown';

const ImpersonationBar = () => {
  const { stopImpersonating } = useUserImpersonation();
  const { user } = useAuth();
  const expiration = user?.impersonation?.expiration;
  const [expiresIn, setExpiresIn] = useState('02:00:00');
  const [days, hours, minutes, seconds] = useCountdown(expiration);

  useEffect(() => {
    setExpiresIn(
      [
        String(hours).padStart(2, '0'),
        String(minutes).padStart(2, '0'),
        String(seconds).padStart(2, '0'),
      ].join(':')
    );
  }, [days, hours, minutes, seconds]);

  useEffect(() => {
    if (expiration && new Date(expiration).getTime() < Date.now()) {
      stopImpersonating();
    }
  }, [expiration, stopImpersonating]);

  if (!user?.impersonation) return null;

  return (
    <div
      data-testid="impersonation-fab"
      aria-label="Impersonation controls"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 z-[9999] w-fit min-w-36 px-2 py-1 flex items-center justify-between gap-2 bg-red-700 rounded-t-xl"
    >
      <div className="flex items-center gap-1.5 text-white text-sm font-light whitespace-nowrap">
        <Icon icon={faUserNinja} className="text-black/50" />
        <span className="tabular-nums">{expiresIn}</span>
      </div>
      <div className="border-l border-black/25 flex items-center justify-center p-1">
        <button
          data-testid="impersonation-stop-btn"
          aria-label="Stop impersonating"
          className="text-white hover:bg-red-600 w-6 h-6 flex items-center justify-center rounded"
          onClick={() => stopImpersonating()}
        >
          <Icon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBar;
